// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"5a2196ee","970":"5bf0ef91"}[chunkId] + ".chunk.js";
};